module.exports = __webpack_public_path__ + "static/img/team.a655450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/team.png
// module id = qZLz
// module chunks = 0